import DropdownActionTypes from './dropdown.types';

export const toggleDropdownHidden = () => ({
    type: DropdownActionTypes.TOGGLE_DROPDOWN_HIDDEN
});